import pkg from '../../package.json';

export const environment = {
  production: true,
  stage: false,
  version: pkg.version,
};
